// SuperAge Liver Age™ — approximate liver-age estimate driven by the Liver
// Risk Score. Purely educational; NOT a clinical measure of fibrosis or
// hepatic function.
//
// Score band → years added to chronological age:
//   0-20   +0
//   21-40  +5
//   41-60  +10
//   61-80  +15
//   81-100 +20
export function liverAgePenalty(score) {
  const s = Number(score);
  if (!Number.isFinite(s)) return null;
  if (s <= 20) return 0;
  if (s <= 40) return 5;
  if (s <= 60) return 10;
  if (s <= 80) return 15;
  return 20;
}

export function computeLiverAge(score, chronoAge) {
  const age = Number(chronoAge);
  const penalty = liverAgePenalty(score);
  if (!Number.isFinite(age) || penalty == null) return null;
  return { chrono: Math.round(age), liverAge: Math.round(age) + penalty, penalty };
}

export const LIVER_AGE_DISCLAIMER =
  "SuperAge Liver Age\u2122 is an approximate estimate based on your liver risk profile and is intended for education and risk communication. It is not a direct measure of liver function or fibrosis.";
